/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Injectable } from '@angular/core';

@Component({
	selector: 'iceloader',
  templateUrl: './iceloader.component.html',
  styleUrls: ['./iceloader.component.scss']
})
@Injectable()

export class IceloaderComponent implements OnInit {
  // Input Members
  @Input() color: string = "";
  @Input() mode: string = "";

  constructor() {
	}

  ngOnInit() {
    this.color = this.color ? this.color : "primary";
    this.mode = this.mode ? this.mode : "indeterminate";
  }
}
